// extracted by mini-css-extract-plugin
module.exports = {"MenuToggle":"MenuToggle_MenuToggle__2pJtd","open":"MenuToggle_open__3KOmk"};